import React from 'react'
import PropTypes from 'prop-types'
import {Spin} from 'antd'
import {CloseOutlined} from '@ant-design/icons'
import {withHumanDelimiters} from 'lib/util'
import Price from 'components/shared/Price'
import Button from 'components/shared/Button'
import './index.scss'

const ShoppingCartLines = ({
  bill,
  isFetchingBill,
  productSelection,
  webOrder,
  removeBundle,
}) => {
  if (isFetchingBill || !bill) {
    return (
      <div className="shopping-cart-lines">
        <div className="loading"><Spin /></div>
      </div>
    )
  }

  const bundle = productSelection.bundleId
    ? webOrder.bundles.edges.find(e => e.node.id === productSelection.bundleId).node
    : null

  const nonBundleLines = bill.lines.filter(l => !l.bundleId)

  const bundleProductsNames = (bundle) => {
    return bundle.products.edges.map(({node: product}) => {
      return `${product.quantity ? `${product.quantity} ` : ''}${product.name}`
    })
  }

  return (
    <div className="shopping-cart-lines">
      <div className="order-total">
        <span>Totalpris eks. MVA</span>
        <span><Price price={bill.sum} /></span>
      </div>

      {!!bundle && (
        <div className="bundle">
          <div className="bundle-name-price">
            <span>{bundle.name}</span>
            <span><Price price={bundle.price} /></span>
            {!!removeBundle && (
              <span className="remove">
                <Button
                  icon={<CloseOutlined />}
                  onClick={() => removeBundle(bundle)}
                />
              </span>
            )}
          </div>
          <div className="bundle-products">
            <span>
              {withHumanDelimiters(bundleProductsNames(bundle))}
            </span>
          </div>
        </div>
      )}

      <div className="products">
        {nonBundleLines.map((line, i) => (
          <div key={i} className="product">
            <span className="name">
              {line.description}
            </span>
            <span className="quantity">
              {line.quantity > 1 ? `${line.quantity} ${line.unit || 'STK'}` : ''}
            </span>
            <span className="price"><Price price={line.sum} /></span>
          </div>
        ))}
      </div>

      <div className="products-total">
        <span>Totalpris ink. MVA</span>
        <span><Price price={bill.sumIncVat} /></span>
      </div>
    </div>
  )
}

ShoppingCartLines.propTypes = {
  productSelection: PropTypes.object.isRequired,
  webOrder: PropTypes.object.isRequired,
  bill: PropTypes.object,
  canEditOrder: PropTypes.bool,
}

export default ShoppingCartLines
